<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <p @click="$router.go(-1)" class="back">back</p>
      <md-card>
        <md-card-content v-if="kiosk" class="md-layout md-gutter">
          <h3>Screen Basics</h3>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Screen Name</label>
              <md-input v-model="kiosk.name" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Teamviewer Id</label>
              <md-input v-model="kiosk.teamviewer_id" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Teamviewer Password</label>
              <md-input v-model="kiosk.teamviewer_password" type="text"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Location</label>
              <md-select v-model="location">
                <md-option :value="l.id" :key="l.id" v-for="l in locations">{{ l.name }}</md-option>
              </md-select>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <md-card-actions md-alignment="space-between">
            <md-button class="md-primary md-round md-small" @click="validate">Save Screen</md-button>
          </md-card-actions>
        </md-card-content>
      </md-card>

      <md-card>
        <md-card-content v-if="kiosk" class="md-layout md-gutter">
          <h3>Screen Content</h3>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Topic Name</label>
              <md-input v-model="kiosk.contentTitle" type="text"></md-input>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Topic Description</label>
              <md-textarea v-model="kiosk.description" type="text"></md-textarea>
              <!-- <span class="md-helper-text">Required</span> -->
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Assigned Flavors</label>
              <md-select multiple v-model="selectedCannabis">
                <md-option v-for="c in cannabis" :value="c.id" :key="c.id">{{ c.name }}</md-option>
              </md-select>
              <span class="md-helper-text">Required</span>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100">
            <label>Screen Background Image</label>
            <Upload :media="kiosk.backgroundImage" @addMedia="addMedia" @removeMedia="removeMedia" />
          </div>
          <md-card-actions md-alignment="space-between">
            <md-button class="md-primary md-round md-small" @click="validate">Save Screen</md-button>
          </md-card-actions>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import { db } from "@/config/firebaseInit";
import firebase from "firebase";
import Swal from "sweetalert2";
import Upload from "@/components/Inputs/Upload.vue";

export default {
  components: {
    Upload
  },
  data() {
    return {
      batch: db.batch(),
      kiosk: {
        name: null,
        slug: null,
        backgroundImage: null,
        teamviewer_id: null,
        teamviewer_password: null,
        last_signal: null,
        cannabis: [],
        location: {
          id: null,
          name: null,
          coords: {
            lat: null,
            lng: null
          }
        }
      },
      locations: [],
      cannabis: [],
      selectedCannabis: [],
      locationCalled: false,
      loc: null
    };
  },
  computed: {
    location: {
      get() {
        try {
          return this.kiosk.location.id;
        } catch (err) {
          console.warn(err);
          return null;
        }
      },
      set(val) {
        if (this.locationCalled) {
          return true;
        }
        let loc = this.locations.find(l => l.id == val);
        this.loc = loc;
        if (loc) {
          this.kiosk.location = {
            id: loc.id,
            coords: {
              lat: loc.address.coords.lat,
              lng: loc.address.coords.lat
            },
            name: loc.name
          };
        }
        this.locationCalled = true;
        let vm = this;
        setTimeout(function() {
          vm.locationCalled = false;
        }, 1000);
      }
    }
  },
  firestore() {
    return {
      locations: db.collection("location"),
      cannabis: db.collection("cannabis")
    };
  },
  watch: {
    kiosk: {
      handler(val) {
        if (this.kiosk && !this.kiosk.created) {
          this.kiosk.slug = this.kiosk.name
            .replace(/[^a-zA-Z0-9]/g, "-")
            .toLowerCase();
        }
      },
      deep: true
    },
    selectedCannabis(newCannabis, oldCannabis) {
      let kioskId = this.$route.params.kiosk_id;

      if (newCannabis.length > oldCannabis.length) {
        let added = newCannabis.find(a => !oldCannabis.includes(a));
        this.kiosk.cannabis = newCannabis;
        if (added) {
          this.updateCannabis(db.collection("cannabis").doc(added), {
            kiosks: firebase.firestore.FieldValue.arrayUnion(kioskId)
          });
        }
      } else {
        let removed = oldCannabis.find(a => !newCannabis.includes(a));
        this.kiosk.cannabis = newCannabis;
        if (removed) {
          this.updateCannabis(db.collection("cannabis").doc(removed), {
            kiosks: firebase.firestore.FieldValue.arrayRemove(kioskId)
          });
        }
      }
    }
  },
  created() {
    let kioskId = this.$route.params.kiosk_id;
    let kioskTemplate = Object.assign({}, this.kiosk);

    this.$bind("kiosk", db.collection("kiosk").doc(kioskId)).then(() => {
      if (!this.kiosk) {
        this.kiosk = kioskTemplate;
      } else {
        this.selectedCannabis = this.kiosk.cannabis;
      }
    });
  },
  methods: {
    validate() {
      let valid = true;
      for (let k in this.kiosk) {
        if (!this.kiosk[k]) {
          if (
            k != "phone" &&
            k != "clicks" &&
            k != "last_signal" &&
            k != "sku" &&
            k != "teamviewer_id" &&
            k != "teamviewer_password" &&
            k != "backgroundImage"
          ) {
            console.log(k);
            valid = false;
          }
        }
      }

      if (valid) {
        this.save();
      } else {
        return Swal.fire("Missing Fields", "Please enter all required fields");
      }
    },
    save() {
      let vm = this;
      if (this.kiosk && !this.kiosk.created) {
        this.kiosk.created = new Date();
        this.kiosk.clicks = 0;
      }
      this.kiosk.location = Object.assign({ id: this.loc.id }, this.loc);
      return db
        .collection("kiosk")
        .doc(this.$route.params.kiosk_id)
        .set(vm.kiosk, { merge: true })
        .then(() => {
          this.batch.commit();
        })
        .then(() => {
          this.batch = db.batch();
          Swal.fire("Success", "Page Updated", "success").then(() => {
            this.$router.go(-1);
          });
        });
    },
    addMedia(link) {
      this.kiosk.backgroundImage = link;
    },
    removeMedia() {
      this.kiosk.backgroundImage = null;
    },
    updateCannabis(ref, data) {
      let batch = db.batch();
      batch.set(ref, data, { merge: true });
      batch.commit();
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
h3 {
  padding: 20px !important;
  padding-top: 0 !important;
  margin-bottom: 20px;
  width: 100%;
}
</style>
